// extracted by mini-css-extract-plugin
export default {"header":"EfficiencyFormHeader_header__5EDez"};